import React from "react";
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import {PROJECT} from '../../utils/constant';
import image from '../../assets/main-image.webp';
import DeviceThermostatOutlinedIcon from '@mui/icons-material/DeviceThermostatOutlined';
import Button from '@mui/material/Button';
import TextWithAnimation from "./TextWithAnimation";

const LandingImage = () => {

    return (
        <Container maxWidth="100%" sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            objectFit: 'cover',
            backgroundPosition: 'bottom',
            fetchPriority: 'eager',
        }}>
            <div className='landing-page-text-section'>
                <div className='landing-page-text landing-page-slogan-text'>
                    <Typography variant="h1" sx={{color: 'white', fontSize: '3rem', fontWeight: 'bold'}}>{PROJECT.SLOGAN}</Typography>
                </div>
                <div className='landing-page-text'>
                    <Typography variant="h1" sx={{color: 'white', fontSize: '2rem', fontWeight: 'bold'}}>Altitud</Typography>
                    <TextWithAnimation></TextWithAnimation>
                    <Typography variant="h1" sx={{color: 'white', fontSize: '2rem', fontWeight: 'bold', marginTop:'10px'}}>Temperatura Promedio</Typography>
                    <div className='temperature-box'>
                        <DeviceThermostatOutlinedIcon sx={{color: 'white', fontSize: '2rem', alignSelf: 'center'}}/>
                        <Typography variant="h1" sx={{color: 'white', fontSize: '2rem', fontWeight: 'bold'}}>5°C–25°C</Typography>
                    </div>
                </div>
            </div>
            <div className='programa-tu-visita'>
                <a href="#contact-us">
                    <Button>Programa tu visita</Button>
                </a>
            </div>
        </Container>
    );
}

export default LandingImage;
